export interface Translation {
    code: string;
    name: string;
}

export const DEFAULT_LANG = 'de';
export const TRANSLATIONS: Translation[] = [
    {
        code: 'de',
        name: 'Deutsch',
    },
    {
        code: 'en',
        name: 'English',
    },
    {
        code: 'tr',
        name: 'Türkisch',
    },
    {
        code: 'fr',
        name: 'Französisch',
    },
    {
        code: 'pl',
        name: 'Polnisch',
    },
    {
        code: 'bs',
        name: 'Bosnisch',
    },
    {
        code: 'hr',
        name: 'Kroatisch',
    },
    {
        code: 'sr',
        name: 'Serbisch',
    },
    {
        code: 'ro',
        name: 'Rumänisch',
    },
    {
        code: 'cs',
        name: 'Tschechisch',
    },
    {
        code: 'sk',
        name: 'Slowakisch',
    },
    {
        code: 'uk',
        name: 'Ukrainisch',
    },
];
